/**
 * Template for Budget filter
 * @param {Object} facette - filter[facetteName]
 * @param {Object} wordings - SEARCH_SCRIPTS.WORDING_SEARCH
 * @return {string} - HTML Content
 */
export const budgetTpl = function (facette, wordings) {
  const {values, selected, code} = facette;
  const facetteName = code.toLowerCase();
  const codeWording = facetteName === 'price' ? 'facette_budget_label_mobile' : 'facette_' + facetteName + '_label_mobile';
  const currencyCode = GLOBAL_SCRIPTS.CURRENCY_CODE;
  const currencyBefore = GLOBAL_SCRIPTS.CURRENCY_BEFORE;
  const currencyAfter = GLOBAL_SCRIPTS.CURRENCY_AFTER;
  const minSelectable = 50;
  const maxSelectable = 3000;
  const baseMinValue = typeof values.min !== 'undefined' ? values.min : minSelectable;
  const baseMaxValue = typeof values.max !== 'undefined' ? values.max : maxSelectable;
  const userMinValue = typeof selected.min !== 'undefined' ? selected.min : baseMinValue;
  const userMaxValue = typeof selected.max !== 'undefined' ? selected.max : baseMaxValue;
  const rangeValues = userMinValue + '_' + userMaxValue + '_' + currencyCode;
  const plus = values.max > maxSelectable ? ' +' : '';

  return `
    <div class="searchFilters-filterTitle" id="filter_${facetteName}">${wordings[codeWording]}</div>
    <div class="searchFilters-filterBudget">
      <div class="form-rangeContainer">
        <div class="form-range js-Search-priceRange"></div>
        <input type="hidden" id="js_facette_budget" name="facet[${facetteName}]" value="${rangeValues}" data-facette="${facetteName}">
        <input type="hidden" id="js_facette_budget_ref" value="[${baseMinValue}, ${baseMaxValue}]">
      </div>
      <div class="form-rangeLegend">
        <span id="form-rangeMin" class="form-rangeLandmark">${currencyBefore}${userMinValue}${currencyAfter}</span>
        <span id="form-rangeMax" class="form-rangeLandmark">${currencyBefore}${userMaxValue}${currencyAfter}<span class="plus">${plus}</span></span>
      </div>
    </div>`;
};
